import React, { useContext } from 'react'
import {
    Tab,
    TabList,
    TabPanels,
    TabPanel,
    TabsContext,
} from 'monday-ui-react-core'
import { StatementContext } from 'utils/context/StatementsContext'
import { ReceiverDashboard } from 'components/ReceiverDashboard'
import { SenderDashboard } from 'components/SenderDashboard'

const Tabs = () => {
    const {
        lastActivePage
    } = useContext(StatementContext)

    return (
        <TabsContext className="monday-storybook-tabs_bg-color tabs-dashboard" activeTabId={lastActivePage === "Receiver" ? 0 : 1}>
            <TabList>
                <Tab>Receiver Dashboard</Tab>
                <Tab>Sender Dashboard</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <ReceiverDashboard />
                </TabPanel>
                <TabPanel>
                    <SenderDashboard />
                </TabPanel>
            </TabPanels>
        </TabsContext>
    )
}

export default Tabs
